export const CREATE_CAMPAIGN = 'CREATE_CAMPAIGN'
export const GET_LIST_CAMPAIGN = 'GET_LIST_CAMPAIGN'
export const GET_CURRENT_CAMPAIGN = 'GET_CURRENT_CAMPAIGN'
export const DETAIL_CAMPAIGN = 'DETAIL_CAMPAIGN'
export const PATCH_CAMPAIGN = 'PATCH_CAMPAIGN'
